import React from 'react';
import { PackageIcon, UsersIcon, MapIcon, SofaIcon, BuildingIcon, HomeIcon, GlobeIcon, TruckIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: UsersIcon,
    title: 'Emergency Courier Drivers for Hire',
    description: 'We supply professional, vetted courier drivers at short notice. Whether you need a driver for a single urgent job or ongoing support, our emergency courier providers are ready to deploy across the UK.'
  }, {
    icon: PackageIcon,
    title: 'Emergency Item & Parcel Delivery',
    description: 'When time is critical, our drivers ensure fast and secure transportation of parcels and items anywhere in the UK — same-day, next-day, or on a schedule that suits you.'
  }, {
    icon: TruckIcon,
    title: 'Contract Delivery Driver Supply',
    description: 'We provide professional contractor delivery drivers to businesses requiring short-term or long-term logistics support. Flexible hiring to match your demand.'
  }, {
    icon: MapIcon,
    title: 'Nationwide Driver Coverage',
    description: 'Our nationwide network of drivers allows us to deploy to any location in the UK quickly and efficiently.'
  }, {
    icon: SofaIcon,
    title: 'Furniture Delivery & Assembly',
    description: 'Our drivers and team offer furniture delivery and build services for homes, offices, and commercial environments.'
  }, {
    icon: BuildingIcon,
    title: 'Office Relocation Services',
    description: 'We supply experienced drivers and handlers for efficient office relocations, ensuring business equipment and furniture are transported safely.'
  }, {
    icon: HomeIcon,
    title: 'House Relocation Services',
    description: 'Moving home? Our drivers and relocation specialists manage the transport and logistics to make your move stress-free.'
  }, {
    icon: GlobeIcon,
    title: 'International Migration Support',
    description: 'We assist with international relocation logistics, supplying drivers and support to help customers move and settle into new locations smoothly.'
  }];
  return <section className="py-20 bg-white" data-id="element-156">
      <div className="container mx-auto px-4" data-id="element-157">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-159">
            Our Services
          </h2>
          <p className="text-lg text-slate-600" data-id="element-160">
            Professional courier drivers for hire and comprehensive delivery
            solutions tailored to your needs, available across the UK.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-161">
          {services.map((service, index) => {
          const Icon = service.icon;
          const isFeatured = index === 0;
          return <div key={index} className={`group rounded-2xl border p-8 transition-all duration-300 relative overflow-hidden ${isFeatured ? 'bg-primary border-primary text-white shadow-xl lg:col-span-2 lg:flex lg:items-center lg:gap-8' : 'bg-white border-slate-200 hover:border-primary hover:shadow-xl'}`} data-id="element-162">
                {isFeatured && <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-4 py-1 rounded-bl-lg z-10" data-id="element-163">
                    OUR SPECIALITY
                  </div>}

                <div className={`h-14 w-14 rounded-xl flex items-center justify-center mb-6 shrink-0 ${isFeatured ? 'bg-white/20 text-white' : 'bg-blue-50 group-hover:bg-primary group-hover:text-white transition-colors'}`} data-id="element-164">
                  <Icon className={`h-7 w-7 ${isFeatured ? 'text-white' : 'text-primary group-hover:text-white transition-colors'}`} data-id="element-165" />
                </div>

                <div data-id="element-166">
                  <h3 className={`text-xl font-bold mb-3 ${isFeatured ? 'text-white text-2xl' : 'text-slate-900'}`} data-id="element-167">
                    {service.title}
                  </h3>
                  <p className={`leading-relaxed ${isFeatured ? 'text-blue-100 text-lg' : 'text-slate-600'}`} data-id="element-168">
                    {service.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}